<template>
  <!-- delete archive Playbooks modal  -->
  <Modal v-model:is-open="delete_surveys_modal_is_open" :use-toast="true" :default-success-msg="$t('Survey(s) Deleted')">
    <template #form="{ close: closeModal, done: showIsDone }">
      <button
        class="inset-y-0 right-0 flex items-center justify-center float-right w-6 h-6 ml-5 rounded-full group hover:bg-gray-300"
        type="button"
        @click="closeModal">
        <X class="w-5 h-5 text-gray-400 group-hover:cursor-pointer" aria-hidden="true" />
      </button>
      <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-dark-body-text">
        {{ $t("Delete selected survey(s)") }}
      </h3>
      <div class="max-w-xl mt-2 text-gray-500 text-md">
        <p>{{ $t("Do you want to delete the selected survey(s)?") }}</p>
      </div>
      <div class="mt-5 text-center">
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 font-medium text-red-700 bg-red-100 border border-transparent rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
          @click="deleteSelectedSurveys(showIsDone)">
          {{ $t("Delete Survey(s)") }}
        </button>
      </div>
    </template>
  </Modal>

  <div class="p-6 h-[calc(100vh-86px)] relative">
    <div class="flex space-x-2 items-center">
      <div class="flex w-full ml-auto rounded-md shadow-sm">
        <div class="relative flex items-stretch flex-grow focus-within:z-10">
          <div class="absolute z-10 inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <Search class="w-5 h-5 text-gray-400" aria-hidden="true" />
          </div>
          <TextInput
            input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
            name="task_name"
            :icon="true"
            type="text"
            :validate-on-input="true"
            :label="$t('Search for Survey')"
            @update:modelValue="
              (e) => {
                search_term = e
              }
            " />

          <RotateCw
            :class="{
              'animate-spin': surveys_loading,
              'opacity-100': surveys_loading
            }"
            class="w-5 h-5 mr-3 -ml-1 opacity-0 absolute right-2 top-2"
            aria-hidden="true" />
        </div>
      </div>

      <div>
        <button class="w-fit btn primary-btn" @click="$emitter.emit(ALL_EMITTERS.CREATE_A_SURVEY, { records: [] })">
          + {{ $t("Create New") }}
        </button>
      </div>
    </div>

    <div v-show="surveys_selected.length" class="flex justify-between h-16 pl-3 pt-5 pb-2">
      <div class="flex items-center gap-2">
        <button type="button" class="danger-btn w-fit" @click="delete_surveys_modal_is_open = true">
          <Trash2 color="red" class="w-5 h-5 mr-2 transition ease-in-out dark:text-white duration-side-menu-transition-duration" />
          {{ $t("Delete Selected Surveys") }}
        </button>
      </div>
    </div>

    <div v-if="surveys?.results?.length" class="grid grid-cols-3 mt-6 max-h-[calc(100vh-230px)] pb-4 overflow-auto">
      <div v-for="survey in surveys.results" :key="survey.id" class="bg-white h-fit mr-4 rounded-lg mb-6 shadow-md p-4">
        <div class="flex items-center justify-between border-b pb-2 relative">
          <div>
            {{ survey.name }}
          </div>

          <input
            v-if="surveys_selected.includes(survey.id)"
            type="checkbox"
            class="mr-3 absolute cursor-pointer right-4 top-0 form-checkbox w-4 z-10 rounded h-4 dark:bg-dark-screen-background"
            :checked="true"
            @input="selectSurvey(survey)">

          <div class="relative">
            <Menu as="div" class="flex-shrink-0 ml-auto">
              <MenuButton
                class="inline-flex items-center justify-center text-gray-400 transition ease-in-out rounded duration-side-menu-transition-duration"
                @click.stop="">
                <EllipsisVertical :color="$store.state.ui.darkMode ? '#fff' : ''" class="w-5 h-5 border-none" />
              </MenuButton>
              <transition
                enter-active-class="transition duration-100 ease-out"
                enter-from-class="transform scale-95 opacity-0"
                enter-to-class="transform scale-100 opacity-100"
                leave-active-class="transition duration-75 ease-in"
                leave-from-class="transform scale-100 opacity-100"
                leave-to-class="transform scale-95 opacity-0">
                <MenuItems
                  class="absolute right-0 z-30 flex flex-col items-start content-center justify-center p-2 mx-3 mt-1 origin-top-right bg-white rounded-md shadow-lg outline-none dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <MenuItem v-slot="{ active }">
                    <div
                      :class="[
                        active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                        'group flex items-center px-3 py-2 text-sm cursor-pointer'
                      ]"
                      @click.stop="selectSurvey(survey)">
                      <SquareDashed class="w-5 h-5 mr-4" /> {{ surveys_selected.includes(survey.id) ? $t("Unselect") : $t("Select") }}
                    </div>
                  </MenuItem>

                  <MenuItem
                    v-slot="{ active }"
                    @click.prevent="
                      () => {
                        $emitter.emit(ALL_EMITTERS.CREATE_A_SURVEY, { records: [], survey })
                      }
                    ">
                    <div
                      :class="[
                        active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                        'group flex items-center px-3 py-2 text-sm cursor-pointer'
                      ]">
                      <Pencil class="w-5 h-5 mr-4" aria-hidden="true" />
                      <span class="whitespace-nowrap">{{ $t("Edit Survey") }}</span>
                    </div>
                  </MenuItem>
                  <MenuItem
                    v-slot="{ active }"
                    @click.prevent="
                      () => {
                        handleDeleteSurvey(survey)
                      }
                    ">
                    <div
                      :class="[
                        active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                        'group flex items-center px-3 py-2 text-sm cursor-pointer'
                      ]">
                      <Trash2 class="w-5 h-5 mr-4 text-red-500" aria-hidden="true" />
                      <span class="whitespace-nowrap">{{ $t("Delete Survey") }}</span>
                    </div>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>

        <div class="flex items-center justify-between w-full mt-1 text-common-grey text-sm">
          <div class="text-common-grey text-sm">
            {{ $t("Created by") }}
          </div>
          <Avatar
            :radius="26"
            :hover-effect="true"
            :first-name="$store.state.data.users.find((u) => u.id == survey.created_by).first_name"
            :last-name="$store.state.data.users.find((u) => u.id == survey.created_by).last_name"
            class="group-hover/name:bg-cyan-500" />
        </div>

        <div class="flex items-center justify-between w-full mt-1">
          <div class="text-common-grey text-sm">
            {{ $t("Number of recipients") }}
          </div>
          <div class="mr-2">
            {{ survey.summary.total_sent }}
          </div>
        </div>

        <div class="flex items-center justify-between w-full mt-1">
          <div class="text-common-grey text-sm">
            {{ $t("Number of responses") }}
          </div>
          <div class="mr-2">
            {{ survey.summary.total_responses }}
          </div>
        </div>

        <div class="flex items-center justify-between w-full mt-1">
          <div class="text-common-grey text-sm">
            {{ $t("Pending responses") }}
          </div>
          <div class="mr-2">
            {{ survey.summary.total_sent - survey.summary.total_responses }}
          </div>
        </div>

        <div class="flex items-center justify-between w-full mt-1">
          <div class="text-common-grey text-sm">
            {{ $t("Submission deadline") }}
          </div>
          <div
            :class="[
              {
                'text-status-warning-yellow':
                  $moment(survey.submissions_end_date) < $moment(orange_date) && $moment(survey.submissions_end_date) >= $moment(new Date())
              },
              { 'text-status-error-red': $moment(survey.submissions_end_date) < $moment(new Date()) },
              { 'text-status-success-green': $moment(survey.submissions_end_date) >= $moment(orange_date) }
            ]"
            class="mr-2 text-black">
            {{ survey.submissions_end_date ? $moment(survey.submissions_end_date).format("DD MMM  YYYY") : "N/A" }}
          </div>
        </div>

        <div class="flex space-x-2 mt-4">
          <button class="btn cancel-btn w-1/2" @click="$emitter.emit(ALL_EMITTERS.SURVEY_RESPONSES, survey)">
            <View class="w-5 h-5 mr-2" color="#899399" /> {{ $t("View responses") }}
          </button>
          <button class="btn primary-btn w-1/2" @click="$emitter.emit(ALL_EMITTERS.SEND_A_SURVEY, survey)">
            <Send class="w-5 h-5 mr-2 text-white" /> {{ $t("Send Survey") }}
          </button>
        </div>
      </div>
    </div>
    <div v-else class="flex items-center justify-center h-full w-full text-center">
      <div class="flex flex-col items-center justify-center space-y-2">
        <div class="flex space-x-2 text-lg font-medium dark:text-white right-4">
          {{ $t("There are no surveys") }}
        </div>
        <div>
          {{ $t("Click on the create new button above to create your first survey") }}
        </div>
      </div>
    </div>
    <div v-if="surveys?.results?.length" class="w-full h-14 overflow-visible rounded-lg dark:bg-dark-box-background">
      <div class="relative top-2">
        <PaginationFooter :default-page-size="page_size" :object="surveys" @update="handlePaginationUpdate" />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationFooter from "@/components/shared/PaginationFooter.vue"
import Avatar from "@/components/shared/Avatar.vue"
import TextInput from "@/components/shared/TextInput.vue"
import { View, Send, SquareDashed, Search, X, Trash2, RotateCw, EllipsisVertical, Pencil } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import dataService from "@/services/data.service"
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import Modal from "@/components/shared/Modal.vue"

export default {
  components: {
    TextInput,
    Modal,
    EllipsisVertical,
    X,
    Search,
    PaginationFooter,
    Avatar,
    RotateCw,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    Pencil,
    View,
    Send,
    Trash2,
    SquareDashed
  },
  props: {},
  emits: [],
  data() {
    return {
      surveys_selected: [],
      ALL_EMITTERS,
      search_term: "",
      surveys_loading: false,
      surveys: { results: [] },
      page_size: 10,
      search_timout: null,
      delete_surveys_modal_is_open: false
    }
  },

  computed: {
    orange_date() {
      const date = new Date()

      return this.addWorkDays(date, 4)
    }
  },
  watch: {
    search_term() {
      clearTimeout(this.search_timout)
      this.search_timout = setTimeout(() => {
        this.getSurveys()
      }, 500)
    }
  },

  unmounted() {
    this.unregister_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },

  activated() {
    this.register_listeners()
  },

  created() {
    this.register_listeners()

    this.getSurveys()
  },

  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.SURVEY_CREATED_INSIDE_SURVEYS_LIST, () => {
        this.getSurveys(1, this.page_size, true)
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.SURVEY_CREATED_INSIDE_SURVEYS_LIST)
    },

    handlePaginationUpdate({ page, page_size }) {
      this.getSurveys(page, page_size)
      this.page_size = page_size
    },
    getSurveys(page = 1, page_size = this.page_size) {
      this.surveys_loading = true
      const params = { page, page_size }
      if (this.search_term) {
        params["search"] = this.search_term
      }
      dataService.getSurveys(params).then((result) => {
        this.surveys_loading = false
        this.surveys = result.data
      })
    },

    deleteSelectedSurveys(callback) {
      this.surveys_selected.forEach((survey) => {
        dataService.deleteSurvey(survey).then(() => {
          const index = this.surveys_selected.findIndex((s) => s == survey.id)
          this.surveys_selected.splice(index, 1)
          if (!this.surveys_selected.length) {
            this.delete_surveys_modal_is_open = false
            callback()
            this.getSurveys()
          }
        })
      })
    },

    handleDeleteSurvey(survey) {
      this.surveys_selected = [survey.id]
      this.delete_surveys_modal_is_open = true
    },

    addWorkDays(startDate, days) {
      if (isNaN(days)) {
        return
      }
      if (!(startDate instanceof Date)) {
        return
      }
      // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
      var dow = startDate.getDay()
      var daysToAdd = parseInt(days)
      // If the current day is Sunday add one day
      if (dow == 0) {
        daysToAdd++
      }
      // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
      if (dow + daysToAdd >= 6) {
        //Subtract days in current working week from work days
        var remainingWorkDays = daysToAdd - (5 - dow)
        //Add current working week's weekend
        daysToAdd += 2
        if (remainingWorkDays > 5) {
          //Add two days for each working week by calculating how many weeks are included
          daysToAdd += 2 * Math.floor(remainingWorkDays / 5)
          //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
          if (remainingWorkDays % 5 == 0) {
            daysToAdd -= 2
          }
        }
      }
      startDate.setDate(startDate.getDate() + daysToAdd)
      return startDate
    },

    selectSurvey(survey) {
      const index = this.surveys_selected.findIndex((s) => s == survey.id)
      if (index !== -1) {
        this.surveys_selected.splice(index, 1)
      } else {
        this.surveys_selected.push(survey.id)
      }
    }
  }
}
</script>
